// extracted by mini-css-extract-plugin
export default {"disable":"menu-item_disable__pzL-Y","menuItemWrapper":"menu-item_menuItemWrapper__MqUp-","active":"menu-item_active__cN-ba"};